import { render, staticRenderFns } from "./ArtistReport.vue?vue&type=template&id=388d7831&scoped=true&"
import script from "./ArtistReport.vue?vue&type=script&lang=js&"
export * from "./ArtistReport.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=388d7831&prod&scoped=true&lang=css&"
import style1 from "./ArtistReport.vue?vue&type=style&index=1&id=388d7831&prod&scoped=true&lang=css&"
import style2 from "./ArtistReport.vue?vue&type=style&index=2&id=388d7831&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d7831",
  null
  
)

export default component.exports